// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Home_tableWrapper__W5BTH","formWrapper":"Home_formWrapper__SXS5r"};